import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  getDeliveryOrderBatches,
  replaceDeliveryOrderBatch,
} from '../../deliveryOrderBatches/deliveryOrderBatchesActions';
import utils from '../../utils/utils';
import ITEM_TEMPERATURE from '../../components/constants/itemTemperature';

const AdminDeliveryDayViewDeliveryBatchTable = ({
  filteredOrderBatches,
  setModalOrder,
  selectedTemperature,
  setModalAddress,
}) => {
  const [typedQuery, setTypedQuery] = useState(null); // for detecting input change
  const [query, setQuery] = useState(null); // for triggering actual search
  const queryTimer = useRef(null);

  useEffect(() => {
    clearTimeout(queryTimer.current);
    queryTimer.current = setTimeout(() => {
      setQuery(typedQuery);
    }, 1000);
  }, [typedQuery]);

  const orderBatches = query
    ? filteredOrderBatches.filter((ob) =>
        ob.orders.some((o) => o.items.some((oi) => oi.itemName.toLowerCase().indexOf(query.toLowerCase()) !== -1))
      )
    : filteredOrderBatches;

  return (
    <>
      <div className="text-right">
        <div className="form-group field field-string d-inline-block">
          <input
            className="form-control"
            placeholder="Search"
            type="text"
            value={typedQuery}
            onChange={(e) => setTypedQuery(e.target.value)}
          />
        </div>
      </div>
      <table className="table table-striped">
        <thead>
          <th scope="col">
            <FormattedMessage id={'delivery.day.view.table.column.user'} />
          </th>
          <th scope="col">
            <FormattedMessage id={'delivery.day.view.table.column.items'} />
          </th>
        </thead>
        <tbody>
          {orderBatches.map((orderBatch, index) => {
            const orderBatchIds = orderBatch.orders
              .map((o) => o.batchId)
              .filter((value, index, self) => self.indexOf(value) === index);

            const filteredOrders = selectedTemperature
              ? orderBatch.orders.filter((order) =>
                  order.items.some((oi) => oi.item.temperature === selectedTemperature)
                )
              : orderBatch.orders;

            return (
              <tr key={index}>
                <th>
                  <div className="cursor-pointer" onClick={() => setModalAddress(orderBatch.address)}>
                    {orderBatch.packingId ? `#${orderBatch.packingId}` : `D${orderBatch.id}`} -{' '}
                    {orderBatch.address
                      ? orderBatch.address.customerName
                      : orderBatch.businessProfile
                      ? orderBatch.businessProfile.companyName
                      : orderBatch.user.screenName}
                  </div>

                  {orderBatch.orders.length && orderBatch.orders[0].deliveryFrom ? (
                    <div className="font-weight-normal">
                      ⏱{' '}
                      {utils.getFormattedDateRangeFromStrings(
                        orderBatch.orders[0].deliveryFrom,
                        orderBatch.orders[0].deliveryTo
                      )}
                    </div>
                  ) : (
                    ''
                  )}
                </th>
                <td>
                  {orderBatch.note ? (
                    <div className="alert alert-info text-left p-a-1 m-b-1">
                      <div>
                        <FormattedMessage id={'delivery.day.view.note'} />:
                      </div>
                      <div className="text-small">{orderBatch.note}</div>
                    </div>
                  ) : (
                    ''
                  )}
                  {orderBatchIds.map((id) => (
                    <div>
                      <small>
                        <Link to={`/admin/orderBatches/${id}`}>#{id}</Link>
                      </small>
                    </div>
                  ))}

                  {orderBatch.businessProfile ? (
                    <div className="text-small">
                      <strong>B2B</strong> <FormattedMessage id={'delivery.day.view.business.profile.id'} />: #
                      {orderBatch.businessProfile.id}
                    </div>
                  ) : (
                    <div className="text-small">
                      <FormattedMessage id={'delivery.day.view.user.id'} />: #{orderBatch.user.id}
                    </div>
                  )}

                  {filteredOrders.map((order, index) => {
                    const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

                    const filteredItems = selectedTemperature
                      ? order.items.filter((oi) => oi.item.temperature === selectedTemperature)
                      : order.items;

                    return (
                      <div key={index} className="m-b-1">
                        <small className="text-muted">
                          {order.marketplaceName} -{' '}
                          <span className="text-primary link" onClick={() => setModalOrder(order)}>
                            <FormattedMessage id={'delivery.day.view.order.refund'} />
                          </span>
                        </small>
                        {filteredItems.map((orderItem, index) => {
                          const orderItemTextClass =
                            query && orderItem.itemName.toLowerCase().indexOf(query.toLowerCase()) !== -1
                              ? 'text-danger'
                              : '';

                          const temperature = orderItem.item.temperature
                            ? tempEnums.find((value) => value.name === orderItem.item.temperature)
                            : null;
                          return (
                            <div key={index} className={orderItemTextClass}>
                              {orderItem.quantity > 1 ? (
                                <strong className="text-primary">{orderItem.quantity} x </strong>
                              ) : (
                                ''
                              )}{' '}
                              {orderItem.itemName} {temperature ? temperature.icon : ''}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

AdminDeliveryDayViewDeliveryBatchTable.propTypes = {
  filteredOrderBatches: PropTypes.array.isRequired,
  setModalOrder: PropTypes.func.isRequired,
  setModalAddress: PropTypes.func.isRequired,
  selectedTemperature: PropTypes.string,
};

AdminDeliveryDayViewDeliveryBatchTable.defaultProps = {};

function mapStateToProps(state) {
  return {
    deliveryOrderBatches: state.deliveryOrderBatches.deliveryOrderBatches,
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {
  getDeliveryOrderBatches,
  replaceDeliveryOrderBatch,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AdminDeliveryDayViewDeliveryBatchTable));
